
import uniqBy from 'lodash/uniqBy'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import FacetsFilters from '../Facets'
import PriceFilter from '../PriceFilter'

import translations from './Refinements.translations'

export default {
  components: {
    FacetsFilters,
    PriceFilter,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      minPrice: 'landingSearch/minPrice',
      maxPrice: 'landingSearch/maxPrice',
      facets: 'landingSearch/facets',
    }),
    isPriceRange() {
      return this.minPrice !== this.maxPrice
    },
    filteredFacets() {
      return uniqBy(this.facets, 'facetName')
    },
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
    handleFacetFilter(facetGroup, value) {
      trackClick({
        name: facetGroup.facetName,
        zone: 'product list > side filter',
        // If value is null, we clicked "All" option to reset the facet
        value: value ?? ['All'],
      })

      this.$emit('change', { [facetGroup.facetName]: value })
    },
  },
}
